<template >
  <div class="forgot-password auth-view">
    <div class="form-wrap">
      <MainLogo/>
      <form class="form" @submit="sync">
        <app-text-input
          :label="'Email'"
          v-model="email"
          v-if="!token && !flagSubmit"
        />
        <span v-if="!token && flagSubmit">
          <!-- TODO добавить перевод и в label -->
          A confirmation email was sent to your mail
        </span>
        <app-text-input
          :label="'New password'"
          v-model="newPassword"
          v-if="token"
          type="password"
        />
        <app-text-input
          :label="'Confirm password'"
          v-model="confirmPassword"
          v-if="token"
          type="password"
        />
        <btn type="submit" v-if="!flagSubmit">Submit</btn>
      </form>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import MainLogo from '@/components/auth/MainLogo';

export default {
  data() {
    return {
      email: null,
      newPassword: null,
      confirmPassword: null,
      token: false,
      flag: false,
      flagSubmit: false
    }
  },
  created () {
    if (this.$route.query.token) {
      this.token = this.$route.query.token;
    }
  },
  methods : {
    async sync(e) {
      e.preventDefault();

      if (!this.token) {
        if (!this.flag) {
          this.sendMail();
        }
      } else {
        this.forgot();
      }
    },
    sendMail() {
      if (this.email) {
        this.flag = true;
        API.auth.sendMail(this.email).then(res => {
          this.flag = false;
          if (res.data.success == true) {
            this.viewNotify('A confirmation email was sent to your mail', 'success');
            this.flagSubmit = true;
          } else {
            this.viewNotify('Wrong email', 'error');
          }
        }).catch(err => {
          this.flag = false;
          this.viewNotify('Wrong email', 'error');
        });
      } else {
        this.viewNotify('Write email please', 'error');
      }
    },
    forgot () {
      if (!this.token) {
        this.viewNotify('Token was not received', 'error');
      } else if (this.newPassword != this.confirmPassword) {
        this.viewNotify('Passwords do not match', 'error');
      } else if (this.token && this.newPassword.length < 6 && this.confirmPassword.length < 6) {
        this.viewNotify('Minimum password length 6 characters', 'error');
      } else {
        API.auth.forgot(this.token, this.newPassword).then(res => {
          if (res.data.success == true) {
            this.viewNotify('Password changed successfully', 'success');
            this.$router.push('/auth/login');
          } else {
            this.viewNotify('An error has occurred, try again', 'error');
          }
        }).catch(err => {
          this.viewNotify('An error has occurred, try again', 'error');
        });
      }
    },
    viewNotify (title, type) {
      this.$notify({
        group: 'notices',
        title,
        type,
      });
    }
  },

  components: {
    MainLogo,
  },
}
</script>

<style lang="scss" scoped>
.form-wrap {
  .form {
    width:400px;
    .text-input {
      margin-bottom: 32px;
    }
    > span {
      display: block;
      width: 100%;
      height: 42px;
      color: $mainGreen;
      font-size: 16px;
      padding: 0 12px;
      margin-bottom: 32px;
      font-family: Roboto;
      text-align: center;
    }
    @media (max-width:768px) {
      width: 100%;
    }
  }
}
</style>
